module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAAElBMVEUAAAAHECcGECoFESkGESoGESqiOxn/AAAABXRSTlMATk/F50qFt5IAAABNSURBVCjPY2AgB4iEAkGIAELAFSQQ6oAQCAURrAFUEACb7IguEAIVMA01gGgJxSUANxSnAFgLc2gwbgH6mEFIABLISN5XQQg4MdAGAACzISfbjwunfAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_home.png
// module id = +93Z
// module chunks = 57